"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAndMergeSliceReducer = createAndMergeSliceReducer;

var _createLeafReducer = require("./internal/create-leaf-reducer");

var _storeHelper = require("./store-helper");
/**
 * Creates and merges a new Top Leaf Reducer for a given sliceName
 */


function createAndMergeSliceReducer(sliceName, initialSlice) {
  var reducer = (0, _createLeafReducer.createLeafReducer)(null, sliceName, initialSlice);

  _storeHelper.storeHelper.mergeTopReducer(reducer);

  return reducer;
}